var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentBookedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 89,
    viewBox: "0 0 90 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2905 17.3516V12.0919H36.4459V17.3422C36.4459 18.4263 37.3245 19.3055 38.4093 19.3055C39.494 19.3055 40.3726 18.4262 40.3726 17.3422V12.0919H58.528V17.3422C58.528 18.4263 59.4073 19.3055 60.4913 19.3055C61.5761 19.3055 62.4554 18.4262 62.4554 17.3422V12.0919H65.8397C67.6029 12.0919 69.2934 12.7921 70.5401 14.0386C71.7868 15.2853 72.4875 16.9757 72.4875 18.7391L72.4875 27.4052H4.33101V18.7485C4.33101 16.9857 5.03182 15.2947 6.27841 14.048C7.52505 12.8014 9.21544 12.1013 10.9789 12.1013H14.3638V17.3016H14.3631V17.3516C14.3631 18.4364 15.2425 19.3149 16.3272 19.3149C17.4113 19.3149 18.2905 18.4363 18.2905 17.3516ZM76.4142 18.7384C76.4142 15.9334 75.2997 13.2438 73.3169 11.2609C71.334 9.27808 68.6444 8.16365 65.8395 8.16365H62.455V2.91335C62.455 1.82926 61.5757 0.95 60.491 0.95C59.4069 0.95 58.5276 1.8293 58.5276 2.91335V8.16365H40.3723V2.91335C40.3723 1.82928 39.4936 0.95 38.4089 0.95C37.3242 0.95 36.4455 1.82931 36.4455 2.91335V8.16365H18.2902V2.91335C18.2902 1.82927 17.4109 0.95 16.3268 0.95C15.2421 0.95 14.3628 1.82929 14.3628 2.91335V8.16365H10.9783C8.17338 8.16365 5.48378 9.27811 3.50091 11.2609C1.51804 13.2438 0.403613 15.9334 0.403613 18.7384V63.5525C0.403613 66.3567 1.51808 69.0463 3.50091 71.0292C5.48378 73.0128 8.17339 74.1265 10.9783 74.1265H65.8384C68.6434 74.1265 71.333 73.0127 73.3159 71.0292C75.2987 69.0463 76.4132 66.3567 76.4132 63.5525L76.4142 18.7384ZM72.4875 63.5627C72.4875 65.3254 71.7867 67.0164 70.5401 68.2631C69.2934 69.5098 67.603 70.2099 65.8396 70.2099H10.9795C9.2163 70.2099 7.5258 69.5097 6.27909 68.2631C5.03244 67.0165 4.33169 65.3254 4.33169 63.5627V31.322H72.4882L72.4875 63.5627Z",
    fill: "#003546",
    stroke: "#007FA8",
    strokeWidth: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.0626,
    cy: 71.5167,
    r: 17.4835,
    fill: "#97C33D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4047 73.1127L68.311 78.6999L81.7204 64.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentBookedIcon);
export default __webpack_public_path__ + "static/media/appointment-booked-icon.289010a6393621d10a4563567aed92af.svg";
export { ForwardRef as ReactComponent };